import { commonGuard } from "../func"

const supportRouter = {
  path: "support",
  component: () => import("@/components/frame/main.vue"),
  children: [
    {
      path: "",
      name: "support",
      redirect: { name: "downloads" },
      component: () => import("@/components/support/index.vue"),
      beforeEnter: commonGuard,
      children: [
        {
          path: "downloads",
          name: "downloads",
          component: () => import("@/components/support/downloads.vue"),
          beforeEnter: commonGuard,
        },
        {
          path: "notice",
          name: "notice",
          component: () => import("@/components/support/notice.vue"),
          beforeEnter: commonGuard,
        },
        {
          path: "notice/:pk",
          name: "notice-detail",
          component: () => import("@/components/support/notice-detail.vue"),
          beforeEnter: commonGuard,
          props: true,
        },
      ],
    },
  ],
}

export default supportRouter
